import type { CellContext, ColumnDef } from '@tanstack/react-table';
import type { TFunction } from 'i18next';
import type { JSX } from 'react';
import React from 'react';

import type { IUrlClicks } from '@feathr/blackbox';
import { NumberCell, Text } from '@feathr/components';

import * as styles from './LinkClicksTableCard.css';

export function getLinkClicksColumns(t: TFunction): Array<ColumnDef<IUrlClicks>> {
  return [
    {
      id: 'url',
      accessorFn: (row): string => row.url,
      header: t('URL'),
      // URLs are the variable-length content here, so they take the leftover width.
      meta: { isFlex: true },
      size: 500,
      sortDescFirst: false,
      cell: ({ row }: CellContext<IUrlClicks, unknown>): JSX.Element => {
        const { url } = row.original;
        // Truncation lives on the block wrapper — it's inert on the inline link itself.
        return (
          <div className={styles.truncate}>
            {url === 'unknown' ? (
              <Text.DefaultRegular truncate={false}>{url}</Text.DefaultRegular>
            ) : (
              <Text.DefaultLink href={url} target={'_blank'} truncate={false}>
                {url}
              </Text.DefaultLink>
            )}
          </div>
        );
      },
    },
    {
      id: 'clicks',
      accessorFn: (row): number => row.clicks,
      header: t('Clicks'),
      meta: { align: 'right' },
      size: 100,
      sortDescFirst: false,
      cell: ({ row }: CellContext<IUrlClicks, unknown>): JSX.Element => (
        <NumberCell format={'count'} value={row.original.clicks} />
      ),
    },
  ];
}
